import ListMixinController from "@/mixins/ListMixinController";

export default {
  mixins: [ListMixinController],
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  computed: {
    userSession() {
      return this.$store.state.userSession;
    },
  },
  data() {
    return {
      columns: [
        {
          name: "Usuário",
          sortName: null,
          order: null,
        },
        {
          name: "Psicólogo",
          sortName: null,
          order: null,
        },
        {
          name: "Denúncia",
          sortName: null,
          order: null,
        },
        {
          name: "Data",
          sortName: null,
          order: null,
        },
        {
          name: "Ações",
          sortName: null,
          order: null,
        },
      ],
    };
  },
  methods: {
    prepareResponse(data) {
      return data.map((elem) => ({
        ...elem,
        // statusObject: this.$tasksService.getTaskStatus(elem.status),
        // pillarObject: this.$missionsService.getMissionPillar(elem.pillar),
      }));
    },
    fetchPromise() {
      return this.$appointmentsService.listReports({
        ...this.filters,
        orderBy: this.columns.filter(
          (r) => r.order != null && r.sortName != null
        ),
      });
    },
  },
};
